import {addVariantToCart } from './shopify';
import {scrollToId} from './main';

$(function(){
    let productMappingTabs = $('.product-mapping-tabs'),
        queryString = new URLSearchParams(window.location.search);

    // NUMBER MIN MAX
    $('body').on('input', 'input[type="number"]', function(){
        let thisInput = $(this),
          min = thisInput.attr('min'),
          max = thisInput.attr('max'),
          val = thisInput.val();

        if (min && Math.ceil(val) < parseInt(min)) {
            thisInput.val(min);
        }

        if (max && Math.ceil(val) > parseInt(max)) {
            thisInput.val(max);
        }
    });

    let modals = {
        'OSD': 'offside',
        'NSD': 'nearside',
        'DRD': 'double',
        'RTR': 'double',
        'RLM': 'double',
        'ISL': 'island',
        'ISA': 'island-angular',
        'I&B': 'island-bolster',
        'MDN': 'double',
        'BUN': 'single',
        'BK2': 'single',
        'TWN': 'single',
        'TW2': 'single',
        'FDB': 'double',
        'MPS': 'multipiece-sides',
    }

    function getModal($key) {
        if (!modals[$key]) {
            return false;
        }

        return modals[$key];
    }

    // TABS
    $('body').on('click', '.product-mapping-tab-trigger', function(){
        let thisTrigger = $(this),
          thisForm = thisTrigger.closest('form'),
          tabId = thisTrigger.attr('aria-controls'),
          nextTab = productMappingTabs.find('#' + tabId);

        let queryString = getFormQueryString(thisForm[0]);

        if (tabId != 'productMappingTab-variant') {
            nextTab.find('.product-mapping-fields').empty();
            nextTab.find('.product-mapping').addClass('tabbing').attr('action', 'https://jonic-mapping.hotfootclients.co.uk/api/'+ thisTrigger.data('api') + '/').attr('data-query', queryString).trigger('submit');
        }

        $('.product-mapping-tab-trigger').attr('aria-selected', 'false');
        thisTrigger.attr('aria-selected', 'true');

        productMappingTabs.find('.product-mapping-tab.open').removeClass('open').fadeOut(200, function(){
            nextTab.addClass('open').fadeIn(200);

            scrollToId(nextTab);
        })
    })

    function getFormQueryString(form) {
        let formData = new FormData(form);

        let queryString = '?';
        let first = true;

        for (let [key, value] of formData.entries()) {
            if (!first) {
                queryString += '&';
            }

            queryString += key + '=' + value.replace('&', '%26');

            first = false;
        }

        return queryString;
    }

    // MAPPING
    $('.product-mapping').each(function(){
        let productMapping = $(this),
            productMappingFields = productMapping.find('.product-mapping-fields');

        if (productMapping.hasClass('init')) {
            initProductMapping();
        }

        if (productMapping.find('.product-calculate').length) {
            productMapping.on('input', 'input', disableCheckout)
        }

        productMapping.on('input', 'input, textarea', function(){
            let thisForm = $(this).closest('form');

            if (thisForm.attr('data-api') === 'product-sizes') {
                if (!validateForm(thisForm)) {
                    disableCheckout();

                    return;
                }

                if ($(this).val().length > 1) {
                    return;
                }

                thisForm.submit();
            }
        })

        productMapping.on('click', '[data-add]', function(e){
            e.preventDefault();

            let thisSubmit = $(this),
              properties = getFormProperties(thisSubmit.closest('form'));

            thisSubmit.siblings('.error').remove();

            addVariantToCart(thisSubmit.data('add'), $('#quantity').val(), properties);
        })

        productMapping.on('change', 'select, input[type="radio"]', function(){
            removePrecedingFields($(this).attr('name'));

            productMapping.submit();
        })

        productMapping.on('click', '.product-calculate-price', function(e){
            e.preventDefault();

            productMapping.submit();
        })

        productMapping.on('submit', function(e){
            e.preventDefault();

            let thisForm = $(this);

            productMapping.find('.product-price').remove();

            if (!validateForm(productMapping)) {
                return;
            }

            let queryString = getFormQueryString(this);

            if (thisForm.attr('data-query')) {
                queryString = thisForm.attr('data-query');

                thisForm.removeAttr('data-query');
            }

            mapFields(queryString, false, thisForm.hasClass('tabbing'));

            thisForm.removeClass('tabbing');
        })

        function getFormProperties($form) {
            let properties = {},
                elements = $form.find('.product-mapping-element');

            if (elements.length === 0) {
                return null;
            }

            elements.each(function(){
                let field = $(this);

                switch (field.prop("tagName")) {
                    case 'SELECT': {
                        properties[field.closest('.form-group').find('> label').text()] = field.find('option:selected').text();

                        break;
                    }
                    default: {
                        if (field.attr('type') === 'radio') {
                            properties[field.closest('.custom-radio, .product-shape-radio-fieldset').find('> legend').text()] = field.closest('.custom-radio, .product-shape-radio-fieldset').find('input:checked').parent().text();
                        } else {
                            properties[field.closest('.form-group').find('> label').text()] = field.val();
                        }

                        break;
                    }
                }
            });

            return properties;
        }

        function validateForm($form) {
            let valid = true;

            $form.find('.error').remove();

            $form.find('.product-mapping-element').each(function(){
                let field = $(this);

                switch (field.attr('type')) {
                    case 'radio': {
                        if (field.closest('.form-group').find('input:checked').length === 0) {
                            valid = false;

                            if (field.closest('.form-group').find('.error').length === 0) {
                                field.closest('.form-group').append('<div class="error">Please complete this field</div>');
                            }
                        }

                        break;
                    }
                    default: {
                        if (!$(this).val()) {
                            valid = false;

                            $(this).closest('.form-group').append('<div class="error">Please complete this field</div>');
                        }

                        break;
                    }
                }
            })

            return valid;
        }

        function removePrecedingFields($name) {
            let fields = productMapping.find('.product-mapping-element'),
              precedingField = false;

            fields.each(function(){
                if ($(this).attr('name') === $name) {
                    precedingField = true;

                    return;
                }

                if (precedingField) {
                    $(this).closest('.form-group, .product-actions').remove();
                }
            });

            productMapping.find('.product-price').remove();
        }

        async function mapFields($queryString = '', $init = false, $tabbing = false) {
            let json = await loadMapping(productMapping.attr('data-variant-id'), $queryString);

            if (json.error) {
                $('.product-submit').before('<div class="error">' + json.error + '<br>Please contact us about this error.</div>');
                disableCheckout();
                return;
            }

            let lastField = productMapping.find('.product-mapping-fields .form-group').last();

            buildForm(json);

            if (json.available_colours && $init) {
                buildAvailableColors(json.available_colours);
            }

            if (json.available_shapes && $init) {
                buildAvailableShapes(json.available_shapes);
            }

            if (json.match) {
                buildCheckout(json.match)
            } else {
                disableCheckout();
            }

            if (!$tabbing) {
                scrollToNextField(lastField);
            }
        }

        function scrollToNextField(lastField) {
            let nextField = lastField.next();

            if (nextField.length === 0) {
                return;
            }

            scrollToId(nextField);
        }

        async function initProductMapping() {
            mapFields('', true);
        }

        function buildAvailableShapes($shapes) {
            let html = '<div class="product-available-shapes def-marg no-marg-bottom"><h2 class="title">Popular shapes</h2>';
            html += '<p>Let us find the right shape for your model, get started by selecting your vehicle above.</p>';
            html += '<ul>';

            for (let [key, shape] of Object.entries($shapes)) {
                html += `<li><span class="product-available-shape" data-shape="${shape}"></span></li>`;
            }

            html += '</ul>';
            html += '</div>';

            $('#productMappingTab-variant').append(html);
        }

        function buildForm($json) {
            for (let [key, object] of Object.entries($json.fields)) {
                buildField(key, object, $json);
            }

            $('select').vinnyselect('init');
        }

        function buildAvailableColors($colors) {
            let html = '<div class="product-available-colors def-marg no-marg-bottom"><h2 class="title">Popular colours</h2><ul>';

            for (let [key, color] of Object.entries($colors)) {
                html += `<li><span class="product-available-color" style="background-color: ${color.hex}"></span>${color.name}</li>`;
            }

            html += '</ul></div>';

            $('.product-features').before(html);
        }

        function buildField($key, $field, $json) {
            if (productMapping.find('#' + $key).length) {
                return;
            }

            let value = '',
                resubmit = false;

            if ($field.value) {
                value = $field.value;
            }

            switch($field.type) {

                case 'select': {
                    if ($key === 'shape') {
                        let html = `<div id="${$key}" class="form-group product-form-group"><fieldset class="product-shape-radio-fieldset"><legend>${$field.label}</legend><div class="product-shape-radios">`;

                        let $options = Object.entries($field.options);

                        for (let [k, option] of $options) {
                            let checked = '';

                            if ($options.length === 1) {
                                checked = 'checked';
                            }

                            if (k === $field.value) {
                                checked = 'checked';
                            }

                            html += `<label class="product-shape-radio">`;
                            html += `<span class="product-shape-radio-icon" data-shape="${k}"></span>`;
                            html += `<input class="sr-only product-mapping-element" type="radio" name="${$key}" value="${k}" required ${checked}/>`;
                            html += `<span class="product-shape-radio-text">${option}</span>`;
                            html += `</label>`;
                        }

                        html += `</div></fieldset>`;

                        if ($field.not_found_text) {
                            html += `<button type="button" class="product-unknown product-mapping-tab-trigger" data-api="${$json.fallback_api}" aria-selected="false" aria-controls="productMappingTab-${$json.fallback_api}">${$field.not_found_text}</button>`;
                        }

                        if ($field.instructions) {
                            html += `<div class="product-instructions">${$field.instructions}</div>`;
                        }

                        html += `</div>`;

                        productMappingFields.append(html);

                        if ($options.length === 1) {
                            productMapping.find(`input[name="${$key}"]`).trigger('change');
                        }

                        break;
                    } else {
                        let html = `<div id="${$key}" class="form-group product-form-group"><label for="${$key}Field">${$field.label}</label>`;

                        if ($field.label.toLowerCase().includes('width') || $field.label.toLowerCase().includes('length')) {
                            if ($json.fields.shape && $json.fields.shape.value) {
                                let $id = getModal($json.fields.shape.value);
                                html += `<button type="button" class="modal-open product-form-information" aria-controls="dimensions-${$id}" aria-label="Open Dimensions Modal"><span>i</span></button>`;
                            }
                        }

                        html += `<select id="${$key}Field" name="${$key}" class="product-mapping-element" required>`;
                        html += `<option value="">Please select...</option>`;

                        let $options = Object.entries($field.options);

                        let $sorted = $options.sort(function(a, b) {
                            if (a[1] < b[1]) return -1;
                            if (a[1] > b[1]) return 1;
                            return 0;
                        });

                        if ($key === 'year') {
                            $sorted.reverse();
                        }

                        for (let [k, option] of $sorted) {
                            let selected = '';

                            // if ($options.length === 1) {
                            //     selected = 'selected';
                            // }

                            if (k === $field.value) {
                                selected = 'selected';
                            }

                            if (typeof option === 'object') {
                                if (queryString.get($key) === option.name) {
                                    selected = 'selected';
                                    resubmit = true;
                                }

                                if (option.hex) {
                                    html += `<option value="${k}" data-color="${option.hex}" ${selected}>${option.name}</option>`;
                                } else {
                                    html += `<option value="${k}" ${selected}>${option.name}</option>`;
                                }
                            } else {
                                if (queryString.get($key) === option) {
                                    selected = 'selected';
                                    resubmit = true;
                                }

                                html += `<option value="${k}" ${selected}>${option}</option>`;
                            }
                        }

                        html += `</select>`;

                        if ($field.not_found_text) {
                            html += `<button type="button" class="product-unknown product-mapping-tab-trigger" data-api="${$json.fallback_api}" aria-selected="false" aria-controls="productMappingTab-${$json.fallback_api}">${$field.not_found_text}</button>`;
                        }

                        if ($field.instructions) {
                            html += `<div class="product-instructions">${$field.instructions}</div>`;
                        }

                        html += `</div>`;

                        productMappingFields.append(html);

                        // if ($options.length === 1) {
                        //     productMapping.find(`select[name="${$key}"]`).trigger('change');
                        // }

                        break;
                    }
                }
                case 'radio': {
                    let html = `<div id="${$key}" class="form-group product-form-group"><fieldset class="custom-radio"><legend>${$field.label}</legend>`;

                    for (let [k, option] of Object.entries($field.options)) {
                        let checked = '';

                        if (k === $field.value) {
                            checked = 'checked';
                        }

                        html += `<label><input type="radio" name="${$key}" value="${k}" class="product-mapping-element" required ${checked}><span class="custom-radio-icon"></span>${option}</label>`;
                    }

                    html += `</fieldset>`;

                    if ($field.not_found_text) {
                        html += `<button type="button" class="product-unknown product-mapping-tab-trigger" data-api="${$json.fallback_api}" aria-selected="false" aria-controls="productMappingTab-${$json.fallback_api}">${$field.not_found_text}</button>`;
                    }

                    if ($field.instructions) {
                        html += `<div class="product-instructions">${$field.instructions}</div>`;
                    }

                    html += `</div>`;

                    productMappingFields.append(html);

                    break;
                }
                case 'text': {
                    let html = `<div id="${$key}" class="form-group product-form-group"><label for="${$key}Field">${$field.label}</label>`;

                    html += `<input type="text" id="${$key}" name="${$key}" class="product-mapping-element" value="${value}" required />`;

                    if ($field.not_found_text) {
                        html += `<button type="button" class="product-unknown product-mapping-tab-trigger" data-api="${$json.fallback_api}" aria-selected="false" aria-controls="productMappingTab-${$json.fallback_api}">${$field.not_found_text}</button>`;
                    }

                    if ($field.instructions) {
                        html += `<div class="product-instructions">${$field.instructions}</div>`;
                    }

                    html += `</div>`;

                    productMappingFields.append(html);

                    break;
                }
                case 'textarea': {
                    let html = `<div id="${$key}" class="form-group product-form-group"><label for="${$key}Field">${$field.label}</label>`;
                    html += `<textarea id="${$key}" name="${$key}" class="product-mapping-element" required>${value}</textarea>`;

                    if ($field.not_found_text) {
                        html += `<button type="button" class="product-unknown product-mapping-tab-trigger" data-api="${$json.fallback_api}" aria-selected="false" aria-controls="productMappingTab-${$json.fallback_api}">${$field.not_found_text}</button>`;
                    }

                    if ($field.instructions) {
                        html += `<div class="product-instructions">${$field.instructions}</div>`;
                    }

                    html += `</div>`;

                    productMappingFields.append(html);

                    break;
                }
                case 'number': {
                    let attr = '';

                    if ($field.min) {
                        attr += ` min="${$field.min}"`;
                    }

                    if ($field.max) {
                        attr += ` max="${$field.max}"`;
                    }

                    let html = `<div id="${$key}" class="form-group product-form-group"><label for="${$key}Field">${$field.label}</label>`;

                    if ($field.label.toLowerCase().includes('width') || $field.label.toLowerCase().includes('length')) {
                        if ($json.fields.shape && $json.fields.shape.value) {
                            let $id = getModal($json.fields.shape.value);
                            html += `<button type="button" class="modal-open product-form-information" aria-controls="dimensions-${$id}" aria-label="Open Dimensions Modal"><span>i</span></button>`;
                        }
                    }

                    html += `<input type="number" id="${$key}" name="${$key}" ${attr} class="product-mapping-element" required value="${value}"/>`;

                    if ($field.not_found_text) {
                        html += `<button type="button" class="product-unknown product-mapping-tab-trigger" data-api="${$json.fallback_api}" aria-selected="false" aria-controls="productMappingTab-${$json.fallback_api}">${$field.not_found_text}</button>`;
                    }

                    if ($field.instructions) {
                        html += `<div class="product-instructions">${$field.instructions}</div>`;
                    }

                    html += `</div>`;

                    productMappingFields.append(html);

                    break;
                }
            }

            if (resubmit) {
                productMapping.submit();
            }
        }

        function buildCheckout(product) {
            let html = `<div class="product-price">${product.price}</div>`;

            productMapping.find('button[type="submit"]').attr('data-add', product.shopify_variant_id).attr('disabled', false);
            productMapping.find('.product-actions').prepend(html);
        }

        function disableCheckout() {
            productMapping.find('button[type="submit"]').attr('disabled', 'disabled');
            productMapping.find('.product-price').remove();
        }

        async function loadMapping($variantId, $queryString = '') {
            return await getJson(productMapping.attr('action') + $variantId + $queryString);
        }

        function getJson(url) {
            return fetch(url, {
                method: "GET",
                mode: "cors",
                headers: {
                    "Content-Type": "application/json",
                }
            }).then(response => response.json())
              .then(function (data) {
                  return data;
              });
        }
    })
})